import loadable from '@loadable/component';
export const Plans=loadable(() => import('./Plans'));
